import React from 'react';

export function HC_DownloadFileOnPhonegap(fileUrl, fileName, sessionId) {
    console.log('HC_DownloadFileOnPhonegap: fileUrl = %s, fileName = %s, sessionId = %s', fileUrl, fileName, sessionId);
    sessionStorage.platform = device.platform;

    var entry, cdr;
    var onGetDirectoryFail = function(e) { console.log('ERROR', e); };
    var onError = function(e) {
        console.log("onError", e);
    };
    var errorHandler = function(e) {
        var msg = '';
        switch (e.code) {
            case FileError.QUOTA_EXCEEDED_ERR:
                msg = 'QUOTA_EXCEEDED_ERR';
                break;
            case FileError.NOT_FOUND_ERR:
                msg = 'NOT_FOUND_ERR';
                break;
            case FileError.SECURITY_ERR:
                msg = 'SECURITY_ERR';
                break;
            case FileError.INVALID_MODIFICATION_ERR:
                msg = 'INVALID_MODIFICATION_ERR';
                break;
            case FileError.INVALID_STATE_ERR:
                msg = 'INVALID_STATE_ERR';
                break;
            default:
                msg = e.code;
                break;
        };
        console.log("Msg - " + msg);
    };

    var writeBlodToFile = function(fileEntry, fileName, data, dataType, success ) {
        var errorHandler = function(e) { console.log('error writing', e) };

        fileEntry.createWriter(function (fileWriter) {
            fileWriter.onwriteend = function (e) {
                console.log('Write of file "' + fileName + '"" completed.');
                if (success) {
                    success();
                }
            };

            fileWriter.onerror = function (e) {
                console.log('Write failed: ' + e.toString());
            };

            var blob = new Blob([data]);
            fileWriter.write(blob);
        }, errorHandler.bind(null, fileName));
    };

    var gotFileEntry = function(fileEntry) {
        var uri = encodeURI(fileUrl);
        $.ajax({
            url: uri + "?hc_session_id=" + sessionId,
            xhrFields: {
                responseType: 'blob'
            },
            type: 'GET',
            success: function (data) {
                console.log('download success', data);
                var successCallBack = function() {
                    window.open(cdr.nativeURL + fileName, '_system');
                };

                writeBlodToFile(fileEntry, fileName, data, data.type, successCallBack);

            },
            error: function(reply) {
                console.log('error downloading', reply);
                console.log('error responseText', reply.responseText)
            }
        });
    };

    var onGetDirectorySuccess = function(dir) {
        dir.getDirectory("files", {create: true, exclusive: false}, onGetDirectorySuccess1, onGetDirectoryFail);
    };
    var onGetDirectorySuccess1 = function(dir) {
        cdr = dir;
        dir.getFile(fileName,{create:true, exclusive:false}, gotFileEntry, errorHandler);
    };

    var onFileSystemSuccess = function(fileSystem) {
        var entry="";
        if (sessionStorage.platform.toLowerCase() == "android") {
            entry=fileSystem;
        }
        else {
            entry=fileSystem.root;
        }
        entry.getDirectory("haccp", {create: true, exclusive: false}, onGetDirectorySuccess, onGetDirectoryFail);
    };

    try {
        if (sessionStorage.platform.toLowerCase() == "android") {
            window.resolveLocalFileSystemURL(cordova.file.externalRootDirectory,onFileSystemSuccess, onError);
        }
        else {
            window.requestFileSystem(LocalFileSystem.PERSISTENT, 0,onFileSystemSuccess, onError);
        }
    }
    catch(err) {
        console.log("ERR - " + err.message);
    }
}


// WEBPACK FOOTER //
// ./phonegapUtils.js